export default "__VITE_ASSET__ZhtLuAzf__"